import React, { Component } from 'react';
import { connect } from 'react-redux';
import privateView from '../../components/hocs/privateView';
import Analytics from '../../services/Analytics';
import KickPointRedemptionForm from './KickPointRedemptionForm';
import Audit from '../../components/Audit/Audit';

class KickPointRedemptionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRefreshLog: true,
    }
    this.setShouldRefreshLog = this.setShouldRefreshLog.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('kick_point_redemption_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentDidUpdate(prevProps) {
    // Refresh the change log after a successful update.
    if (prevProps.isSubmit !== this.props.isSubmit && !this.props.isSubmit) {
      this.setState({ shouldRefreshLog: true });
    }
  }

  setShouldRefreshLog(value) {
    this.setState({ shouldRefreshLog: value });
  }

  render() {
    const id = this.props.match.params && this.props.match.params.id;
    return (
      <>
        <KickPointRedemptionForm
          edit
          title="Kick Point Redemption Detail"
          {...this.props}
        />
        <Audit
          id={Number(id)}
          type={"kick_point_redemption"}
          refresh={this.state.shouldRefreshLog}
          onSetRefresh={this.setShouldRefreshLog}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth: { isFetch, roles, isLogged, id, email }, kickPointRedemption } = state;
  return {
    guardData: { isFetch, roles, isLogged, id, email },
    isSubmit: kickPointRedemption.isSubmit,
  }
}

const enhance = connect(mapStateToProps);
export default enhance(privateView(KickPointRedemptionDetail, ['superadministrator', 'administrator']));
